import { Pipe, PipeTransform } from "@angular/core";
import { now, toDate } from "app/main/helpers/timezone.helper";
import { TZ } from "../enums/Timezone.enum";

@Pipe({
  name: "relativeDate",
})
export class RelativeDatePipe implements PipeTransform {
  transform(date: Date): string {
    const today = now(TZ.HN).startOf("day");
    const dateMoment = toDate(date, TZ.HN).startOf("day");
    const diffInDays = today.diff(dateMoment, "days");

    return diffInDays === 0
      ? "Hoy"
      : diffInDays === 1
      ? "Ayer"
      : `Hace ${diffInDays} días`;
  }
}
